import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Dictionary } from '../../base/dictionary';
import { WUniqueFormat } from '../../base/unique-format';
import { WUniqueFormats } from '../../base/unique-formats';
import { WParagraphStyle } from './style';
/* eslint-disable */
/**
 * @private
 */
export class WListFormat {
    constructor(node) {
        this.uniqueListFormat = undefined;
        this.ownerBase = undefined;
        this.baseStyle = undefined;
        this.list = undefined;
        this.ownerBase = node;
    }
    get nsid() {
        return this.getPropertyValue('nsid');
    }
    set nsid(id) {
        this.setPropertyValue('nsid', id);
    }
    get listId() {
        return this.getPropertyValue('listId');
    }
    set listId(listId) {
        if (listId >= 0) {
            if (!isNullOrUndefined(this.ownerBase)) {
                let helper = this.ownerBase.getDocumentHelperObject();
                if (!isNullOrUndefined(helper)) {
                    this.list = helper.getListById(listId);
                }
            }
        }
        else if (!isNullOrUndefined(this.list) && listId < 0) {
            this.list = undefined;
        }
        this.setPropertyValue('listId', listId);
    }
    get listLevelNumber() {
        return this.getPropertyValue('listLevelNumber');
    }
    set listLevelNumber(value) {
        this.setPropertyValue('listLevelNumber', value);
    }
    get listLevel() {
        let list = undefined;
        if (!isNullOrUndefined(this.list)) {
            list = this.list;
        }
        else {
            let baseListStyle = this.baseStyle;
            while (!isNullOrUndefined(baseListStyle) && baseListStyle instanceof WParagraphStyle) {
                if (baseListStyle.paragraphFormat.listFormat.list) {
                    list = baseListStyle.paragraphFormat.listFormat.list;
                    break;
                }
                else {
                    baseListStyle = baseListStyle.basedOn;
                }
            }
        }
        if (!isNullOrUndefined(list)) {
            return list.getListLevel(this.listLevelNumber);
        }
        else {
            return undefined;
        }
    }
    getPropertyValue(property) {
        if (!this.hasValue(property)) {
            if (this.baseStyle instanceof WParagraphStyle) {
                let baseStyle = this.baseStyle;
                while (!isNullOrUndefined(baseStyle)) {
                    if (baseStyle.paragraphFormat.listFormat.hasValue(property)) {
                        break;
                    }
                    else {
                        baseStyle = baseStyle.basedOn;
                    }
                }
                if (!isNullOrUndefined(baseStyle)) {
                    const propertyType = WUniqueFormat.getPropertyType(WListFormat.uniqueFormatType, property);
                    return baseStyle.paragraphFormat.listFormat.uniqueListFormat.propertiesHash.get(propertyType);
                }
            }
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(WListFormat.uniqueFormatType, property);
            if (!isNullOrUndefined(this.uniqueListFormat) && this.uniqueListFormat.propertiesHash.containsKey(propertyType)) {
                return this.uniqueListFormat.propertiesHash.get(propertyType);
            }
        }
        return WListFormat.getPropertyDefaultValue(property);
    }
    setPropertyValue(property, value) {
        if (isNullOrUndefined(value) || value === '') {
            value = WListFormat.getPropertyDefaultValue(property);
        }
        if (isNullOrUndefined(this.uniqueListFormat)) {
            this.initializeUniqueListFormat(property, value);
        }
        else {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueListFormat.uniqueFormatType, property);
            if (this.uniqueListFormat.propertiesHash.containsKey(propertyType) &&
                this.uniqueListFormat.propertiesHash.get(propertyType) === value) {
                //Do nothing, since no change in property value and return
                return;
            }
            this.uniqueListFormat = WListFormat.uniqueListFormats.updateUniqueFormat(this.uniqueListFormat, property, value);
        }
    }
    initializeUniqueListFormat(property, propValue) {
        const uniqueListFormatTemp = new Dictionary();
        this.addUniqueListFormat('listId', property, propValue, uniqueListFormatTemp);
        this.addUniqueListFormat('listLevelNumber', property, propValue, uniqueListFormatTemp);
        this.addUniqueListFormat('nsid', property, propValue, uniqueListFormatTemp);
        this.uniqueListFormat = WListFormat.uniqueListFormats.addUniqueFormat(uniqueListFormatTemp, WListFormat.uniqueFormatType);
    }
    addUniqueListFormat(property, modifiedProperty, propValue, uniqueListFormatTemp) {
        const propertyType = WUniqueFormat.getPropertyType(WListFormat.uniqueFormatType, property);
        if (property === modifiedProperty) {
            uniqueListFormatTemp.add(propertyType, propValue);
        }
    }
    static getPropertyDefaultValue(property) {
        let value = undefined;
        switch (property) {
            case 'listId':
                value = -1;
                break;
            case 'listLevelNumber':
                value = 0;
                break;
            case 'nsid':
                value = -1;
                break;
        }
        return value;
    }
    copyFormat(format) {
        if (!isNullOrUndefined(format)) {
            if (!isNullOrUndefined(format.uniqueListFormat) || (!isNullOrUndefined(format.baseStyle) && !isNullOrUndefined(format.baseStyle.paragraphFormat.listFormat)
                && !isNullOrUndefined(format.baseStyle.paragraphFormat.listFormat.uniqueListFormat) && isNullOrUndefined(format.list))) {
                this.listId = format.listId;
                this.listLevelNumber = format.listLevelNumber;
                this.nsid = format.nsid;
            }
            if (!isNullOrUndefined(format.baseStyle)) {
                this.baseStyle = format.baseStyle;
            }
            if (!isNullOrUndefined(format.list)) {
                this.list = format.list;
            }
        }
    }
    hasValue(property) {
        if (!isNullOrUndefined(this.uniqueListFormat)) {
            const propertyType = WUniqueFormat.getPropertyType(this.uniqueListFormat.uniqueFormatType, property);
            return this.uniqueListFormat.propertiesHash.containsKey(propertyType);
        }
        return false;
    }
    clearFormat() {
        if (!isNullOrUndefined(this.uniqueListFormat) && this.uniqueListFormat.referenceCount === 0) {
            WListFormat.uniqueListFormats.remove(this.uniqueListFormat);
        }
        this.uniqueListFormat = undefined;
        this.list = undefined;
    }
    destroy() {
        if (!isNullOrUndefined(this.uniqueListFormat)) {
            WListFormat.uniqueListFormats.remove(this.uniqueListFormat);
        }
        this.uniqueListFormat = undefined;
        this.list = undefined;
        this.ownerBase = undefined;
        this.baseStyle = undefined;
    }
    static clear() {
        this.uniqueListFormats.clear();
    }
    applyStyle(baseStyle) {
        this.baseStyle = baseStyle;
    }
    getValue(property) {
        return this.hasValue(property) ? this.getPropertyValue(property) : undefined;
    }
    //This method logic is not correct for changing the style dialog. Instead of this created assign format method and used it..
    // public mergeFormat(format: WListFormat): void {
    //     if (isNullOrUndefined(this.getValue('listId'))) {
    //         this.listId = format.getValue('listId') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('listLevelNumber'))) {
    //         this.listLevelNumber = format.getValue('listLevelNumber') as number;
    //     }
    //     if (isNullOrUndefined(this.getValue('nsid'))) {
    //         this.nsid = format.getValue('nsid') as number;
    //     }
    //     if (!isNullOrUndefined(format.list)) {
    //         if (isNullOrUndefined(this.list)) {
    //             this.list = new WList();
    //         }
    //         this.list.mergeList(format.list);
    //     }
    // }
    cloneListFormat() {
        const format = new WListFormat(undefined);
        format.list = this.list;
        format.listId = this.listId;
        format.nsid = this.nsid;
        format.baseStyle = this.baseStyle;
        format.listLevelNumber = this.listLevelNumber;
        format.uniqueListFormat = this.uniqueListFormat;
        return format;
    }
}
WListFormat.uniqueListFormats = new WUniqueFormats();
WListFormat.uniqueFormatType = 7;
